/*
---
description: Global notify widget system
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.4.0: '*'
- Destructor
provides: [Notify]
...
*/
var Notify = new Class({
	Implements: [Events, Options, Destructor],
	options: {
		cls: 'w_notify',
		content: '',
		position: {x: 0, y: 0},
		centered: false,
		time_to_live: null,
		template: null // string template
	},
	initialize: function(_target, options) {
		if (_target) {
			this._target = _target;
			this.setOptions(options);
			this.build();
		}
	},
	build: function() {
		var markup = this.generate_markup();
		var _element = this._element = this.generate_element_from_markup(markup);

		if (!_element) { return; }

		_element.inject(document.body).hide();

		_element.addEvent('click', this.self_destruct.bind(this));

		if(this.options.time_to_live){
			var self = this;
			(function(){
				self.self_destruct();
			}.delay(this.options.time_to_live));
		}
	},
	self_destruct: function(e) {
		if (this.timer) {
			clearTimeout(this.timer);
		}
		var fx = new Fx.Morph(this._element, {
			duration: 300
		});

		fx.start({
			opacity: 0
		}).chain(function() {
			this._element.dispose();
			this.destruct();
		}.bind(this));
	},
	generate_element_from_markup: function(markup) {
		var opts = this.options;
		var _element = Elements.from(markup)[0] || null;

		(function(){
			_element.show();


			if(opts.centered){
				var win_size = window.getSize();
				var win_scroll = window.getScroll();

				var pos_y = win_scroll.y + Math.floor(Math.max(0, (win_size.y - _element.getSize().y)/2));
				var pos_x = win_scroll.x + Math.floor(Math.max(0, (win_size.x - _element.getSize().x)/2));

				_element.setStyles({
					left: pos_x,
					top: pos_y
				});
			}else{
				var x = opts.position.x + _element.getSize().x;
				_element.setStyles({
					left: ((x >= window.innerWidth)? (window.innerWidth - _element.getSize().x) : opts.position.x),
					top: opts.position.y
				});
			}


		}.delay(300));

		_element.getElements('a').each(function(_a) {
			if (_a.get('href').contains('#')) {
				_a.addEvent('click', function(e) {
					e.preventDefault();
				});
			}
  		});

		return _element;
	},
	generate_markup: function() {
		var opts = this.options;

		var template = opts.template || Notify.Template.Standard;

		var markup = template.substitute({
			cls: opts.cls,
			content: opts.content
		});

		return markup;
	}
});

Notify.Template = {};

Notify.Template.Standard = ''+
	'<div class="{cls} _standard">'+
		'<div class="{cls}_content">{content}</div>'+
	'</div>';
